module.exports = __webpack_public_path__ + "static/media/swagger.73542e40.yaml";